import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('clearRecipientWell')(async function clearRecipientWell(
    recipientWell: RecipientWellWithFindControlViewState
) {
    recipientWell.recipients = [];
    recipientWell.isDirty = true;
});
